import React, { lazy, Suspense } from 'react';
import { BrowserRouter as Router, Navigate, Route, Routes } from 'react-router-dom';
import KioskSetup from './KioskSetup';
import TestimonialCarouselDemo from './TestimonialCarouselDemo';
// Lazy-load the 982 KB AdminDashboard so the browser only downloads + parses it
// when the user first hits /admin — not on initial page load.
const AdminDashboard = lazy(() => import('./AdminDashboard'));

function App() {
  return (
    <Router>
      <Suspense fallback={
        <div style={{
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          height: '100vh', background: '#0f172a', color: '#94a3b8',
          fontFamily: 'system-ui, sans-serif', fontSize: 15, gap: 10
        }}>
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#6366f1" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" style={{ animation: 'spin 1s linear infinite' }}>
            <path d="M21 12a9 9 0 1 1-6.219-8.56" />
          </svg>
          Loading dashboard…
          <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
        </div>
      }>
        <Routes>
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/admin/login" element={<AdminDashboard />} />
          <Route path="/kiosk-setup" element={<KioskSetup />} />
          <Route path="/testimonial-carousel" element={<TestimonialCarouselDemo />} />
          <Route path="*" element={<Navigate to="/admin" replace />} />
        </Routes>
      </Suspense>
    </Router>
  );
}

export default App;
